import WaveDivider from '../WaveDivider/waveDivider';
import styles from './StatusPage.module.css';
import Header from '../Header';
import Footer from '../Footer';

function StatusPage({
  waveColor = 'yellow', // yellow, red, or green
  legionImage,
  contentHeading,
  contentHeadingTag,
  buttonCont
}) {
  return (
    <>
      <WaveDivider color={waveColor} animate={true} />
      <div className="container original">
        <Header hideTimer hideCancelBtn />
        <main className={styles.mainContainer}>
          <div
            className={styles.bigHero}
            style={{
              backgroundImage: `url(${legionImage})`
            }}
          ></div>
          <section id="mainContent" className={styles.contentContainer}>
            <h1 className={`${styles.contentHeading} heading1`}>
              {contentHeading}
            </h1>
            <div className={styles.contentHeadingTag}>{contentHeadingTag}</div>
            <div className={styles.buttonCont}>{buttonCont}</div>
          </section>
        </main>
        <Footer />
      </div>
    </>
  );
}

export default StatusPage;
